import { isNonEmptyString } from '@sindresorhus/is';
import { AbstractMigration } from '../base/abstract-migration.ts';

export class MatchDatasourcesMigration extends AbstractMigration {
  override readonly propertyName = 'matchDatasources';

  override run(value: unknown): void {
    // v8 ignore else -- TODO: add test #40625
    if (Array.isArray(value)) {
      const newValue = value.filter(isNonEmptyString).map((datasource) => {
        switch (datasource) {
          case 'adoptium-java':
            return 'java-version';
          case 'dotnet':
            return 'dotnet-version';
          case 'node':
            return 'node-version';
          default:
            return datasource;
        }
      });

      this.rewrite(newValue);
    }
  }
}
